import { takeEvery, all } from "redux-saga/effects";
import authSaga from "./authSaga";
import {
  ADMIN_LOGIN,
  FETCH_ADMIN_DASHBOARD_STATS,
  FETCH_ADMIN_PROFILE,
  FETCH_ADMIN_TRANSACTIONS,
  FETCH_ADMIN_USERS,
  FETCH_ADMIN_WALLET,
  FETCH_FAQS,
  FETCH_PROFILE_TYPE,
  FETCH_TRANSACTIONS,
  FETCH_WALLET_TYPE,
  LOGIN_TYPE,
  SETUP_2FA_TYPE,
  SIGN_UP_TYPE,
} from "../actions/authActionType";
import userSaga from "./userReducer";
import twoFASetupSaga from "./twoFASaga";
import walletSaga from "./walletSaga";
import transactionsSaga from "./transactionSaga";
import supportFAQSaga from "./faqSaga";
import adminUsersSaga from "./adminUsersSaga";
import adminTransactionsSaga from "./adminTransactionsSaga";
import adminWalletSaga from "./adminWalletSaga";
import adminDashboardSaga from "./adminDashboardSaga";
import adminAuthSaga from "./adminAuthSaga";
import adminProfileSaga from "./adminProfileSaga";

function* rootSaga() {
  yield all([
    takeEvery(LOGIN_TYPE, authSaga),
    takeEvery(SIGN_UP_TYPE, authSaga),
    takeEvery(FETCH_PROFILE_TYPE, userSaga),
    takeEvery(SETUP_2FA_TYPE, twoFASetupSaga),
    takeEvery(FETCH_WALLET_TYPE, walletSaga),
    takeEvery(FETCH_TRANSACTIONS, transactionsSaga),
    takeEvery(FETCH_FAQS, supportFAQSaga),
    takeEvery(FETCH_ADMIN_USERS, adminUsersSaga),
    takeEvery(FETCH_ADMIN_TRANSACTIONS, adminTransactionsSaga),
    takeEvery(FETCH_ADMIN_WALLET, adminWalletSaga),
    takeEvery(FETCH_ADMIN_DASHBOARD_STATS, adminDashboardSaga),
    takeEvery(ADMIN_LOGIN, adminAuthSaga),
    takeEvery(FETCH_ADMIN_PROFILE, adminProfileSaga),
  ]);
}

export default rootSaga;
